/**
 * Ταμείο: κάρτα/IRIS του τραπεζιού που δεν κατέληξε σε πληρωμή (utils/dineInCardDoubt). Μόνο ένδειξη — μπαίνει
 * στην οθόνη τραπεζιού και στην πληρωμή, ώστε να φαίνεται και μετά από F5.
 */

import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { CardDoubt, cardDoubtText } from '../../utils/dineInCardDoubt';

const CardDoubtNotice: React.FC<{ doubts: CardDoubt[]; className?: string }> = ({ doubts, className = '' }) => {
  if (doubts.length === 0) return null;
  return (
    <div className={`space-y-2 ${className}`} data-testid="card-doubt">
      {doubts.map((d) => {
        const { title, detail } = cardDoubtText(d);
        const running = d.state === 'in_flight';
        return (
          <div
            key={d.transactionId}
            role={running ? 'status' : 'alert'}
            data-testid={`card-doubt-${d.state}`}
            className={`flex items-start gap-2 px-3 py-2.5 rounded-xl text-sm leading-snug ${
              running
                ? 'bg-blue-50 dark:bg-blue-900/30 border border-blue-300 dark:border-blue-700/50 text-blue-900 dark:text-blue-200'
                : 'bg-red-50 dark:bg-red-900/30 border-2 border-red-500 dark:border-red-600 text-red-900 dark:text-red-200'
            }`}
          >
            {running
              ? <Loader2 className="w-5 h-5 shrink-0 mt-0.5 animate-spin" />
              : <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" />}
            <div className="space-y-0.5">
              <p className="font-bold">{title}</p>
              <p>{detail}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CardDoubtNotice;
